module.exports = __webpack_public_path__ + "img/9370.dd7cbfb6.jpg";